/**
 * @file Send to Loot, browser side — shared by the device page and the
 * offboarding workflow. The work happens server-side (sendToLoot callable,
 * through the IT Hub).
 */

import { toast } from '../utils.js';

/** Toast for a Send to Loot result. */
export function reportLootResult(res) {
  if (res?.slack && !res.slack.ok && !res.slack.skipped) {
    toast(`On Loot as a draft, BUT the Finance message failed — ${res.slack.error || 'unknown'}.`, 'error', 8000);
  } else {
    toast(res?.already ? 'Already on Loot.' : 'On Loot as a draft.', 'success');
  }
}

/** Loot's deep link → the path the hub opens inside Loot. */
export function lootPath(url) {
  try {
    const u = new URL(url);
    return `${u.pathname}${u.search}${u.hash}`;
  } catch {
    return '/admin/';
  }
}
